import { Formik } from 'formik'
import omit from 'lodash-es/omit'
import React from 'react'

import { CreateSiteProvider, useCreateSite } from '@fourthwall/module-create-site'
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider'

import type { Data, FormValues } from './CreateNewSiteModal.types'
import { CreateNewSiteModalView } from './CreateNewSiteModalView'
import { useCreateAdditionalShopMutation } from './queries/useCreateAdditionalShopMutation'
import { getPayloadFromFormValues } from './utils/getPayloadFromFormValues'
import { getValidationSchema } from './utils/getValidationSchema'

export type CreateNewSiteModalContainerProps = {
  onSuccess?: (data: Data) => void
}

const CreateNewSiteModalContainerComponent = ({ onSuccess }: CreateNewSiteModalContainerProps) => {
  const { initialValues, searchChannel } = useCreateSite()
  const { createAdditionalShopMutation } = useCreateAdditionalShopMutation()
  const { timezone } = useShopTime()

  const handleSubmit = async (values: FormValues) => {
    await createAdditionalShopMutation.mutateAsync([getPayloadFromFormValues(values, timezone)], {
      onSuccess,
    })
  }

  return (
    <Formik<FormValues>
      validationSchema={getValidationSchema(searchChannel.manualURLType)}
      initialValues={{
        ...omit(initialValues, 'theme'),
        siteForSomeoneElse: false,
      }}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      <CreateNewSiteModalView searchChannel={searchChannel} />
    </Formik>
  )
}

export const CreateNewSiteModalContainer = ({ ...props }: CreateNewSiteModalContainerProps) => (
  <CreateSiteProvider options={{ themesLibraryEnabled: false }}>
    <CreateNewSiteModalContainerComponent {...props} />
  </CreateSiteProvider>
)
